import { render, staticRenderFns } from "./QuestionnaireQRCode.vue?vue&type=template&id=010dbf8c&scoped=true"
import script from "./QuestionnaireQRCode.vue?vue&type=script&lang=js"
export * from "./QuestionnaireQRCode.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireQRCode.vue?vue&type=style&index=0&id=010dbf8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010dbf8c",
  null
  
)

export default component.exports